import { createContext, useContext, useState, useCallback, useEffect } from "react";
import AlertModal from "../components/AlertModal";

const AlertContext = createContext(null);

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlert must be used within an AlertProvider");
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    title: "",
    message: "",
  });

  const showAlert = useCallback((title, message) => {
    const normalizedTitle = message === undefined ? "Alert" : title;
    const normalizedMessage = message === undefined ? title : message;

    setAlertState({
      isOpen: true,
      title: typeof normalizedTitle === "string" ? normalizedTitle : "Alert",
      message:
        typeof normalizedMessage === "string"
          ? normalizedMessage
          : String(normalizedMessage ?? ""),
    });
  }, []);

  const closeAlert = useCallback(() => {
    setAlertState((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }, []);

  useEffect(() => {
    const nativeAlert = window.alert;
    window.alert = (message) => showAlert("Alert", message);

    return () => {
      window.alert = nativeAlert;
    };
  }, [showAlert]);

  return (
    <AlertContext.Provider value={{ showAlert, closeAlert }}>
      {children}
      <AlertModal
        open={alertState.isOpen}
        title={alertState.title}
        message={alertState.message}
        onClose={closeAlert}
      />
    </AlertContext.Provider>
  );
};
